module.exports = __webpack_public_path__ + "static/media/ic_advertising_gray.a887d6fa.svg";